/**
 * Detect supported transition event
 * https://jonsuh.com/blog/detect-the-end-of-css-animations-and-transitions-with-javascript/
 * @returns {String}
 */
function whichTransitionEvent() {
  let t,
      el = document.createElement('fake');

  let transitions = {
    'transition'      : 'transitionend',
    'OTransition'     : 'oTransitionEnd',
    'MozTransition'   : 'transitionend',
    'WebkitTransition': 'webkitTransitionEnd',
  };

  for (t in transitions) {
    if (el.style[t] !== undefined) {
      return transitions[t];
    }
  }
}

let transitionEvent = whichTransitionEvent();

export default transitionEvent;



// WEBPACK FOOTER //
// ./source/js/components/whichTransitionEvent.js